import { format } from "date-fns/format";
import { de, enCA, enGB, enUS, es, fr, Locale } from "date-fns/locale";
import { IntlShape } from "react-intl";

export const getCalendarLocale = (locale: string): Locale => {
  switch (locale) {
    case "es-ES":
    case "es":
      return es;
    case "en-GB":
      return enGB;
    case "en-CA":
      return enCA;
    case "en-US":
    case "us":
    case "en":
      return enUS;
    case "de-DE":
    case "de":
      return de;
    case "fr-FR":
    case "fr":
      return fr;
    default:
      return enGB;
  }
};

export const formatIntl =
  (intl: IntlShape) => (date: Date, formatString: string) => {
    const locale = getCalendarLocale(intl.locale);
    return format(date, formatString, { locale });
  };
